import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom'
import { clearSession, isAuthenticated } from '../lib/portal'

const LANDING_NAV = [
  { to: '/verify',   label: 'Doğrula' },
  { to: '/sign',     label: 'İmzala' },
  { to: '/docs',     label: 'Geliştirici' },
  { to: '/download', label: 'İndir' },
  { to: '/hakkimizda', label: 'Hakkımızda' },
]

const PORTAL_NAV = [
  { to: '/dashboard',   label: 'Belgelerim' },
  { to: '/gelistirici', label: 'Geliştirici' },
  { to: '/account',     label: 'Hesap' },
]

function navClass({ isActive }: { isActive: boolean }) {
  return `rounded px-3 py-1.5 text-sm transition-colors ${
    isActive
      ? 'bg-[var(--color-bg-soft)] text-[var(--color-fg)]'
      : 'text-[var(--color-fg-muted)] hover:bg-[var(--color-bg-soft)] hover:text-[var(--color-fg)]'
  }`
}

export default function TopBar() {
  // useLocation makes the bar re-render on every navigation — auth transitions always
  // navigate (login → /dashboard, logout → /login), so the menu reflects session state
  // without a global auth context.
  useLocation()
  const navigate = useNavigate()
  const authed = isAuthenticated()

  const logout = () => {
    clearSession()
    navigate('/login')
  }

  return (
    <header className="sticky top-0 z-50 border-b border-[var(--color-border)] bg-[var(--color-bg)]/85 backdrop-blur">
      <div className="container-page flex h-14 items-center justify-between">
        <Link to={authed ? '/dashboard' : '/'} className="flex items-center gap-2 font-mono text-sm font-medium">
          <span className="grid h-7 w-7 place-items-center rounded bg-[var(--color-accent)] text-white">W</span>
          <span>W.Sign</span>
          {!authed && <span className="badge ml-1">kurumsal e-imza</span>}
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {(authed ? PORTAL_NAV : LANDING_NAV).map(item => (
            <NavLink key={item.to} to={item.to} className={navClass}>
              {item.label}
            </NavLink>
          ))}
        </nav>

        {authed ? (
          <button onClick={logout} type="button" className="btn-ghost text-xs">
            Çıkış
          </button>
        ) : (
          <div className="flex items-center gap-2">
            <Link to="/login" className="btn-ghost text-xs">Giriş</Link>
            <Link to="/destek" className="btn-primary text-xs">İletişim</Link>
          </div>
        )}
      </div>
    </header>
  )
}
